import { type FC, memo } from 'react';
import { goodsListByWorkshop } from '@common/constants';
import { type GoodsType } from '@common/types/goods';
import { type ShortProductData } from '@common/types/workshopType';
import { selectContractItemList } from '@redux/selectors/contractSelectors';
import { useAppSelector } from '@redux/store';

import { LockGoodsItem } from '../GoodsItem/GoodsItem';
import { GoodsSelection } from '../GoodsSelection/GoodsSelection';

interface GoodsListProps {
  data: ShortProductData[];
  workshopName: string;
  isNextToBuild?: boolean;
  production?: {
    goods: GoodsType;
    percentage: number;
  };
}

const GoodsList: FC<GoodsListProps> = memo(
  ({ data, workshopName, production }) => {
    const contractItems = useAppSelector(selectContractItemList);

    return (
      <div className="flex items-center gap-1 relative z-[5]">
        {data.map((props, index) => {
          const productionPercentage =
            production && production.goods === props.name
              ? production.percentage
              : undefined;

          return (
            <GoodsSelection
              size={{ width: '3.5rem', height: '3.5rem' }}
              key={props.id || index}
              name={props.name}
              withStar={
                contractItems ? contractItems.includes(props.name) : false
              }
              productionPercentage={productionPercentage}
            />
          );
        })}
        {workshopName in goodsListByWorkshop &&
          goodsListByWorkshop[workshopName]
            .filter((_, index) => index >= data.length)
            .map((_, index) => {
              const kof = data.length + index;
              const lvl = kof !== 0 ? (data.length + index) * 5 : 1;

              return (
                <LockGoodsItem
                  key={index}
                  classNames={{ icon: '!w-4 !h-4' }}
                  lvl={lvl}
                  size={{ width: '3.5rem', height: '3.5rem' }}
                />
              );

              // return isNextToBuild ? (
              //   <LockGoodsItem
              //     classNames={{ icon: '!w-4 !h-4' }}
              //     lvl={lvl}
              //     size={{ width: '3.5rem', height: '3.5rem' }}
              //   />
              // ) : (
              //   <GoodsSelection
              //     size={{ width: '3.5rem', height: '3.5rem' }}
              //     key={index}
              //     name={goodName as GoodsType}
              //     lvl={lvl}
              //     withStar={
              //       contractItems ? contractItems.includes(goodName) : false
              //     }
              //   />
              // );
            })}
      </div>
    );
  },
);

export { GoodsList };
